import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

export const LLM_CHAT_ANALYTICS_ACTIONS = {
  SUBMITTED_LLM_CHAT_REACTION_FEEDBACK: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'submitted_llm_chat_reaction_feedback',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SAVED_LLM_GENERATED_DOCUMENT: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'saved_llm_generated_document',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SENT_LLM_CHAT_MESSAGE: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'sent_llm_chat_message',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  OPENED_LLM_CHAT: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'opened_llm_chat',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_SUGGESTED_ACTION: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'clicked_suggested_action',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_LLM_CHAT_FROM_SUGGESTED_ACTION: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'created_llm_chat_from_suggested_action',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  OPENED_LLM_CHAT_FROM_HISTORY: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'opened_llm_chat_from_history',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_AI_SIDEPANEL: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'opened_ai_sidepanel',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_AI_TENANT_SETTINGS: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'opened_ai_tenant_settings',
    actionCategory: ACTION_CATEGORY.READ,
  },
  VIEWED_AI_TRIAL_HOMEPAGE: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'viewed_ai_trial_homepage',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_AI_TRIAL_SIGNUP_MODAL: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'opened_ai_trial_signup_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SUBMITTED_EMAIL_IN_AI_TRIAL_SIGNUP_MODAL: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'submitted_email_in_ai_trial_signup_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SUBMITTED_FORM_IN_AI_TRIAL_SIGNUP_MODAL: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'submitted_form_in_ai_trial_signup_modal',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  ENDED_COMPOSE_REALTIME_VOICE_SESSION: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'ended_compose_realtime_voice_session',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  FOCUSED_START_CHAT_INPUT: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'focused_start_chat_input',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SUBMITTED_START_CHAT_QUESTION: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'submitted_start_chat_question',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CLICKED_GLOBAL_ENTRY_FROM_COMPOSE: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'clicked_global_entry_from_compose',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  VIEWED_GLOBAL_ENTRY_FROM_COMPOSE: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'viewed_global_entry_from_compose',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_AI_SETTINGS_PANEL: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'opened_ai_settings_panel',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SAVED_RESPONSE_PREFERENCES: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'saved_response_preferences',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CLICKED_TEMPLATE_FROM_COMPOSE: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'clicked_template_from_compose',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  VIEWED_TEMPLATE_FROM_COMPOSE: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'viewed_template_from_compose',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CREATED_CHAT_FOR_ENTRY: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'created_chat_for_entry',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  VIEWED_ENTITY_ASK_BUTTON: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'viewed_entity_ask_button',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_ENTITY_ASK_BUTTON: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'clicked_entity_ask_button',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  VIEWED_INVENTORY_ASK_BUTTON: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'viewed_inventory_ask_button',
    actionCategory: ACTION_CATEGORY.READ,
  },
  VIEWED_STUDY_GENERATE_REPORT_BUTTON: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'viewed_study_generate_report_button',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_STUDY_GENERATE_REPORT_BUTTON: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'clicked_study_generate_report_button',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
};
